import React from 'react';

const SiteLogo = ({
  alt = 'Sarkari Adda 24x7',
  className = '',
  loading = 'eager',
  priority = false,
}) => (
  <picture>
    <source
      type="image/avif"
      srcSet="/api/media/images/logo-header-v2-80.avif 80w, /api/media/images/logo-header-v2-160.avif 160w"
      sizes="(min-width: 768px) 71px, 64px"
    />
    <img
      src="/api/media/images/logo-header-v2-80.webp"
      srcSet="/api/media/images/logo-header-v2-80.webp 80w, /api/media/images/logo-header-v2-160.webp 160w"
      sizes="(min-width: 768px) 71px, 64px"
      width="160"
      height="122"
      alt={alt}
      loading={loading}
      decoding="async"
      fetchpriority={priority ? 'high' : 'auto'}
      className={className}
    />
  </picture>
);

export default SiteLogo;
